import ApiCore from "../utilities/core";

const url = 'users';
const plural = 'users';
const single = 'users';

// plural and single may be used for message logic if needed in the ApiCore class.

export const apiUsers = new ApiCore({
    getAll: true,
    getSingle: true,
    post: true,
    put: true,
    patch: true,
    delete: false,
    url: url,
    plural: plural,
    single: single,
    requireToken: true
});

apiUsers.massUpdate = () => {
    // Add custom api call logic here
}